<template>
  <div class="wrapper">
    <div class="content">
      <div class="pane left-pane">
        <img class="intro-image" src="../../static/images/intro.jpg"/>
      </div>
      <div class="pane">
        <h1 class="title">London Terror Attack</h1>
        <div class="intro-text">
          <p>
            Horrific news continues to come out of London days after fanatics unleashed terror into the heart of the city, mowing down pedestrians in a van then rampaging on foot through a packed nightlife area. Eight innocents were killed - among them two Australians - and 48 injured. This interactive shows the route the three attackers took and places they targeted, in 360-vision with witness footage from the scene.
          </p>
          <div class="actions">
            <button class="start-button" @click="onClick">Start</button>
            <img class="intro-logo" src="../../static/images/logo.png" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['onStart'],
  methods: {
    onClick () {
      this.onStart()
    }
  }
}
</script>
<style scoped>
 @import url('https://fonts.googleapis.com/css?family=Arapey');
 .wrapper {
   width: 100vw;
   min-height: 100vh;
   height: auto;
   position: absolute;
   left:0px;
   top:0px;
   z-index: 10;
 }
 .title {
   font-family: 'Arapey', serif;
   font-size: 2em;
 }
 .content {
   width: 100%;
   max-width: 800px;
   margin: 0px auto;
   padding: 24px;
   box-sizing: border-box;
   display: flex;
   flex-direction: column;
   align-items: center;
   justify-content: space-around;
 }

 .pane {
   flex: 1;
   min-width: 50%;
   display: flex;
   flex-direction: column;
   align-items: center;
   justify-content: center;

 }
 .actions {
   display: flex;
   flex-direction: column;
   align-items: center;
   margin-top: 20px;
 }
 .start-button {
    padding: 12px 84px;
    border:1px solid #FFF;
    color:#FFF;
    border-radius: 50px;
    font-family: serif;
    font-weight: bold;
    font-size: 1em;
    margin-bottom: 20px;
    cursor: pointer;
    background: transparent;
 }

 .intro-text {
   width: 100%;
   max-width: 400px;
   text-align: center;
   font-family: serif;
   font-size: 1em;
 }

 .intro-image {
   max-width: 80%;
 }
 .intro-logo {
   width: 236px;
   height: 25px;
 }

 .flash {
  width:100%;
  height: 100px;
  position: absolute;
  opacity: 0.5;
  animation: police .35s infinite;
  animation-direction: alternate;
  z-index:-1;
 }
 .flash.top {
  top:0px;
  left: 0px;
 }

 @keyframes police {
  0% {background: linear-gradient(#E25E5E, rgba(0,0,0,0));}
  100% {background: linear-gradient(#7C91B0, rgba(0,0,0,0));}
}

 @media (max-width: 450px) {
   .content {
     max-width: 100%;
     flex-direction: column;
   }
   .title {
     font-size: 2em;
   }
   .pane {
     flex: 4;
   }
   .pane.left-pane {
     flex: 1;
   }
   .actions {
     align-items: center;
   }
   .intro-text {
    font-size: smaller;
   }
 }
</style>



// WEBPACK FOOTER //
// Intro.vue?40fc6503